import React from 'react';

import {
  AlertV2,
  Gallery /* already on v2 */,
  LoadingV2,
  Banner /* already on v2 */,
  ModalV2,
  ProductCustomisationModalV2,
  UpsellModalV2,
  ProductAnimationSpawnV2,
  MiniCartModalV2,
  AddonRemovedModalV2,
  useCategoryView,
} from '@fingermarkglobal/cringer.components';

const CustomCategoryView = () => {
  const {
    ready,
    loading,
    menuState,
    formattedProducts,
    t,
    openGroupedProductModal,
    onCloseGroupedProductModal,
    groupedProductSelected,
    openComboProductModal,
    onCloseComboProductModal,
    comboProductSelected,
    customisationProductSelected,
    openProductCustomisationModal,
    onCloseProductCustomisationModal,
    onConfirmProductCustomisationModal,
    openUpsellModal,
    formattedUpsells,
    onCloseUpsellModal,
    modalAccessibilityClass,
    showPriceWarning,
    showMiniCartModal,
    onCloseMiniCartModal,
    onConfirmMiniCartModal,
    originPath,
    formatPrice,
    isCustomisationHeaderEnabled,
    isCustomiseCategoryTitleEnabled,
    isCategoryTotalizerEnabled,
    isAdditionalMessageEnabled,
    showQuantityControllerLabel,
    galleryMaxColumns,
    showBanner,
    bannerTitle,
    bannerSubTitle,
    bannerImage,
    placeholder,
    showAddonAvailability,
    openCondAddonModal,
    onCloseAddonRemovedModal,
    hideDisabledButtons,
    hidePriceWhenQuantityLessOrEqualDefault,
    hidePriceWhenZero,
    shouldChangeAddButtonText,
    isCouponQuantityDisabled,
  } = useCategoryView({ showCategoriesHeader: true });

  // openProductCustomisationModal could be directAdd, customise or null
  const addToCartDirectly = openProductCustomisationModal === 'directAdd';
  const showCustomisationModal = addToCartDirectly ? 'hidden' : '';

  return (
    <>
      <ProductAnimationSpawnV2 />
      <ModalV2 open={showMiniCartModal} formatPrice={formatPrice}>
        <MiniCartModalV2
          onCloseCallback={onCloseMiniCartModal}
          onConfirmCallback={onConfirmMiniCartModal}
          origin={originPath}
          showPriceWarning={showPriceWarning}
          disableModifyUpsellOnCart={true}
          isCouponQuantityDisabled={isCouponQuantityDisabled}
          hideDisabledButtons={hideDisabledButtons}
        />
      </ModalV2>
      <ModalV2
        data-test="grouped-option-modal"
        className={`${modalAccessibilityClass} grouped-option-modal`}
        open={openGroupedProductModal}
        title={groupedProductSelected?.title}
        closeModal={onCloseGroupedProductModal}
        closeText={t('categoryGroupedModalSecondaryAction')}
        formatPrice={formatPrice}
      >
        <Gallery
          items={groupedProductSelected?.grouped}
          dynamicColumns={true}
          formatPrice={formatPrice}
          showAddonAvailability={showAddonAvailability}
          showEnergyInformationSeparated={true}
          t={t}
        />
      </ModalV2>
      <ModalV2
        data-test="combo-option-modal"
        className={`combo-option-modal ${modalAccessibilityClass}`}
        open={openComboProductModal}
        title={t('categoryComboModalTitle')}
        closeModal={onCloseComboProductModal}
        closeText={t('categoryComboModalSecondaryAction')}
        formatPrice={formatPrice}
      >
        <Gallery
          items={comboProductSelected?.options}
          dynamicColumns={true}
          formatPrice={formatPrice}
          showAddonAvailability={showAddonAvailability}
          showEnergyInformationSeparated={true}
          t={t}
        />
      </ModalV2>
      <ModalV2
        open={!!openProductCustomisationModal}
        className={`${modalAccessibilityClass} ${showCustomisationModal}`}
        formatPrice={formatPrice}
      >
        <ProductCustomisationModalV2
          addToCartDirectly={addToCartDirectly}
          product={customisationProductSelected}
          onCloseCallback={onCloseProductCustomisationModal}
          onConfirmCallback={onConfirmProductCustomisationModal}
          showPriceWarning={showPriceWarning}
          isCustomisationHeaderEnabled={isCustomisationHeaderEnabled}
          isCustomiseCategoryTitleEnabled={isCustomiseCategoryTitleEnabled}
          isCategoryTotalizerEnabled={isCategoryTotalizerEnabled}
          isAdditionalMessageEnabled={isAdditionalMessageEnabled}
          showQuantityControllerLabel={showQuantityControllerLabel}
          showAddonAvailability={showAddonAvailability}
          showModifierEnergyInformation={true}
          titleSeparator={' | '}
          hidePriceWhenQuantityLessOrEqualDefault={hidePriceWhenQuantityLessOrEqualDefault}
          hidePriceWhenZero={hidePriceWhenZero}
          shouldChangeAddButtonText={shouldChangeAddButtonText}
        />
      </ModalV2>
      <UpsellModalV2
        open={openUpsellModal}
        closeModal={onCloseUpsellModal}
        t={t}
        products={formattedUpsells}
        className={modalAccessibilityClass}
        formatPrice={formatPrice}
        showAddonAvailability={showAddonAvailability}
        showEnergyInformationSeparated={true}
      />

      <ModalV2 open={openCondAddonModal && !showMiniCartModal}>
        <AddonRemovedModalV2 onCloseCallback={onCloseAddonRemovedModal} />
      </ModalV2>
      {(loading || !ready) && (
        <div className="category-view--loading">
          <LoadingV2 />
        </div>
      )}
      {menuState?.matches('failure') && (
        <div className="category-view--failure">
          <AlertV2 type="danger" message={menuState.context.message} />
        </div>
      )}

      {showBanner && (
        <Banner
          title={bannerTitle}
          subTitle={bannerSubTitle}
          image={bannerImage}
          placeholder={placeholder}
        />
      )}

      {menuState?.matches('success') && (
        <Gallery
          descriptive={false}
          items={formattedProducts}
          showEnergyInformationSeparated={true}
          galleryCardClassName={'gallery-card-category'}
          formatPrice={formatPrice}
          maxColumns={galleryMaxColumns}
          showAddonAvailability={showAddonAvailability}
          t={t}
        />
      )}
    </>
  );
};

export { CustomCategoryView };
